/*
  «Расчёт платежей» рядом с условиями рассрочки - выбор владельца 13.10.2026
  (вариант Б макетов, название - его же).

  Показывает, какой взнос услышит должник при условиях, которые сейчас стоят в
  форме, - до сохранения. Числа приходят с сервера (`useInstalmentPreview`):
  это те же числа, что лежат готовой таблицей в инструкции агента.

  В таблице не все сроки, а опорные: до тридцати строк подряд читаются как
  справочник, а нужно увидеть порядок взноса. Самый долгий срок показан всегда -
  его агент предлагает первым.
*/

import { money } from '../api/format.js'
import { Field, Notice } from './Common.jsx'

const MILESTONES = [3, 6, 12, 24, 36]

function shownRows(preview) {
  const longest = preview.longest
  return preview.rows.filter(
    (row) => MILESTONES.includes(row.months) || row.months === longest,
  )
}

function Explanation({ offered, debt, preview, pending }) {
  if (!offered) {
    return (
      <p className="muted">
        Рассрочку вы не предоставляете: агент о ней не говорит, на странице должника её нет.
      </p>
    )
  }
  if (!debt) return <p className="muted">Введите долг, чтобы увидеть расчёт.</p>
  if (!preview || (pending && !preview.rows.length)) return <p className="muted">Считаем…</p>
  if (!preview.rows.length) {
    return (
      <p className="muted">Долг меньше двух наименьших взносов - рассрочка ему не нужна.</p>
    )
  }
  return null
}

export default function InstalmentPreview({
  offered,
  debt,
  onDebt,
  exampleDebt,
  preview,
  pending,
  error,
}) {
  const ready = offered && debt && preview && preview.rows.length > 0
  const longest = ready ? preview.rows[preview.rows.length - 1] : null

  return (
    <section className="card" aria-labelledby="instalment-preview-title">
      <h2 className="group__title" id="instalment-preview-title">
        Расчёт платежей
      </h2>

      <Field
        label="Долг для примера, ₽"
        width="s"
        hint={
          exampleDebt
            ? `Подставлен типичный долг ваших счетов - ${money(exampleDebt)}: половина долгов меньше, половина больше. Можно ввести любой.`
            : 'Счетов в работе пока нет - введите любой долг, чтобы увидеть расчёт.'
        }
      >
        <input
          className="field__input"
          inputMode="decimal"
          value={debt}
          onChange={(event) => onDebt(event.target.value)}
        />
      </Field>

      {error ? <Notice error={error} /> : null}
      <Explanation offered={offered} debt={debt} preview={preview} pending={pending} />

      {ready ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Срок</th>
                <th className="table__num">Платёж в месяц</th>
              </tr>
            </thead>
            <tbody>
              {shownRows(preview).map((row) => (
                <tr key={row.months}>
                  <td>{row.months} мес.</td>
                  <td className="table__num" data-label="Платёж в месяц">
                    {money(row.payment)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {preview.shortened ? (
            <p className="muted">
              Срок сокращён до {longest.months} мес.: при большем взнос был бы меньше наименьшего.
            </p>
          ) : null}
          <p className="muted">
            Агент первым предложит самый долгий срок: {longest.months} мес., около{' '}
            {money(longest.payment)} в месяц. Последний взнос добирает копейки остатка.
          </p>
        </>
      ) : null}
    </section>
  )
}
